var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("layout-1", {
        staticStyle: { width: "100%", height: "calc(100vh - 50px)" },
        attrs: {
          table_name: "Contracts",
          id: _vm.pageid,
          searchbar: false,
          searchbardate: true,
          custombuttons: [8, 9, 10],
          navbar: true,
          nav_items: ["Add Contract"],
          nav_item_perms: ["83"],
          button_perm: "83",
          button_name: "Select",
          term: _vm.term,
          reroute: "/0319",
          select_reroute: false
        },
        on: { selectCustom: _vm.selectCustom, select: _vm.select }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-08f0d5b2", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-08f0d5b2","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/view/Contracts.vue
// module id = 562
// module chunks = 0